<template>
  <v-container style="padding-top:3rem;padding-bottom: 5rem; min-height: 100vh;  height: inherit;overflow-y: auto;">
    <v-form ref="form" lazy-validation>
      <v-row justify="center">
        <v-col class="d-flex flex-column" cols="12" sm="6">
          <div class="text-h5 font-weight-bold primary--text">
            인증번호 입력
            <!-- Certification number -->
          </div>
          <div class="desc-box text-subtitle-2">
            
            <span>입력해주신 휴대전화 번호로</span>
            <span>인증번호를 전송했습니다.</span>
            <span>전송된 인증번호를 입력해주세요.</span>
            
<!--             
            <span>The verification code has </span>
            <span>been sent as input information.</span>
            <span>Please enter the verification code.</span> -->

          </div>
          <v-text-field
            type="number"
            v-model="token"
            :error-messages="error"
            :rules="[rules.required]"
            class="my-4"
            clearable
            required
            v-on:keyup.enter="onSubmit"
            label="수신한 인증코드를 입력해주세요"
          ></v-text-field>
          <v-text-field
            type="text"
            v-model="recommend"
            class="my-4"
            clearable
            required
            label="추천코드(선택사항)"
            v-on:keyup.enter="onSubmit"
          ></v-text-field>
 

          <v-checkbox
            v-if="isFirst"
            v-model="service"
            :error-messages="error"
            :rules="[rules.service]"
            label="서비스 이용약관"
            @click="onService"
          ></v-checkbox>          

          <v-checkbox
            v-if="isFirst"
            v-model="finance"
            :error-messages="error"
            :rules="[rules.finance]"
            label="전자금융거래 이용약관"
            @click="onFinance"
          ></v-checkbox>           

          <!-- <v-select :items="psiteList" v-model="psite" required label="매장">
          </v-select> -->
        </v-col>
      </v-row>
      <!-- <v-row>
        <v-col cols="6">
          <v-btn
            class="font-weight-bold"
            tile
            fixed
            x-large
            style="width:50%;z-index: 5;left: 0;bottom: 0px;height: 56px;"
            to="/signin"
          >
            돌아가기
          </v-btn>
        </v-col>
        <v-col cols="6"> -->
          <!-- {{ this.refer_code }} -->
        <v-btn
          class="font-weight-bold"
          color="primary"
          x-large
          block
          @click="onSubmit"
          :disabled="loading"
        >
          Login
        </v-btn>

      <!-- </v-col>
      </v-row> -->
    </v-form>
 
    <v-dialog v-model="termsModal" persistent max-width="30rem">
          <v-card>
            <v-card-title   ></v-card-title>
            <v-card-text  >
              <div v-html="termsTxt" ></div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-0 primary" style ="">
              <v-btn
                color="#000000"
                
                
                width="100%"
                text
                x-large
                class="font-weight-bold"
                @click="termsModal = false"
              >
                확인
              </v-btn> 
               
            </v-card-actions>
          </v-card>
        </v-dialog> 

  </v-container>
</template>

<script>
export default {
  data: () => ({
    isFirst: false ,
    refer_code:null , 
    token: '',
    recommend: '',
    psite: '',
    psiteList: [],
    termsTxt:null , 
    termsModal : false , 
    service:false, 
    finance:false, 
    terms : null , 
    

    rules: {
      required: (value) => !!value || '인증코드를 입력하세요.' , 
      service: (value) => !!value || '서비스 이용약관 확인하세요.' , 
      finance: (value) => !!value || '전자금융거래 이용약관 확인하세요.' 
    },
    error: ''
  }),
  computed: {
    loading() {
      return this.$store.getters.loading
    }
  },
  methods: {
    onService(){
      
      if( this.service ==  true ) {
        this.termsModal = true ;         
        this.termsTxt = this.terms.service ; 
      }
    } ,     
    onFinance(){
      
      if( this.finance ==  true ) {
        this.termsModal = true ;         
        this.termsTxt = this.terms.finance ; 
      }
    } , 

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$store.commit('loading', true)
        const params = {
          phone: this.$route.params.phone,
          token: this.token.trim(),
          recommend: this.recommend,
          psite: this.psite

        }
        this.$store
          .dispatch('LOGIN', params)
          .then((res) => {
            this.$store.commit('loading', false)
            if (!res) {
              throw new Error('no response')
            } else if (res.status) {
              // if (this.autoLogin) {
              //   localStorage.accessToken = res.token
              // }
              // this.$store.dispatch('FETCH_USERINFO').then((res) => {
              // this.$store.commit('loading', false)

              //   try {
              //     loginSuccess(this.email, res.token)
              //   } catch (error) {
              //     this.$store.commit('loading', false)
              //     console.log(error)
              //   }
              //   if (!res.data.user.auth_sms || res.data.user.auth_sms === 'N') {
              //     this.$router.push('/phone/verify')
              //     return
              //   }

              //   this.$store.commit('activeMenu', 'home')
              // })
              this.$cookies.remove('psite')
              this.$cookies.remove('recommend')
              this.$router.push('/home')
            } else if (res.code === 'token') {
              this.error = '잘못된 인증번호 입니다.'
            } else if (res.code === 'timeout') {
              this.error = '인증번호 유효시간이 초과되었습니다.'
            }
          })
          .catch((err) => {
            this.error = '인터넷 연결이 불안정합니다. 잠시후 다시 시도해주세요.'
          })
      }
    }
  },
  created() {
    this.$store
      .dispatch('psite')
      .then((res) => {
        // console.log(res)
        if (res.data.result) {

          this.terms = res.data.terms  ;
          const data = res.data.data ; 
          

          this.psiteList = Object.keys(data).map((item) => ({
            text: data[item],
            value: item
          }))
        } else throw res
      })
      .catch((err) => {
        this.error = '인터넷 연결이 불안정합니다. 잠시후 다시 시도해주세요.'
      })

    if (!this.$route.params.phone) this.$router.replace('/signin')
    
    const psite = this.$cookies.get('psite')
    if (psite) this.psite = psite
    const recommend = this.$cookies.get('recommend')
    if (recommend) this.recommend = recommend ; 


    if( this.$route.params.firstLogin == true)  {
      this.isFirst = true  
    } else{ 
      this.finance = true ; 
      this.service = true ;    
    } ;

    // this.refer_code =  this.$cookies.get('refer_code')  ;     
    // console.log("refer_code ::?? "  ,  this.$cookies.get('refer_code') )
  }
}
</script>

<style>
.desc-box {
  background-color: #f1f1f1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  margin: 1rem 0;
}
</style>
